// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resource-picker-header {
  padding: 15px 15px 0px 15px;
}

.resource-picker-option {
  vertical-align: middle;
  border: 1px solid lightgrey;
  border-bottom-width: 0px;
  padding: 15px;
}
.resource-picker-option span {
  display: inline-block;
  font-size: 16px;
  vertical-align: middle;
  word-break: break-word;
  max-width: 420px;
}
.resource-picker-option .resource-picker-filename {
  color: #a9a9a9;
}
.resource-picker-option i {
  display: inline-block;
  vertical-align: middle;
  font-size: 40px;
  padding-left: 20px;
  padding-right: 40px;
}

.resource-picker-option:hover {
  cursor: pointer;
  background: #fafaff;
}

.resource-picker-body-scroll {
  max-height: 500px;
  overflow-y: auto;
}

.resource-picker-file-upload-label {
  display: initial;
  max-width: initial;
  margin-bottom: initial;
  font-weight: initial;
}

.disclaimer-body {
  padding: 20px;
  border-radius: 3px;
}
.disclaimer-body p {
  display: inline-block;
  max-width: 450px;
}
.disclaimer-body .disclaimer-body-icon {
  font-size: 40px;
  padding-right: 20px;
  vertical-align: top;
}
.disclaimer-body .disclaimer-body-checkbox-div {
  display: block;
  margin-top: 10px;
}
.disclaimer-body .disclaimer-body-checkbox-div .disclaimer-body-checkbox {
  vertical-align: top;
}
.disclaimer-body .disclaimer-body-checkbox-div .disclaimer-body-checkbox:hover {
  cursor: pointer;
}
.disclaimer-body .disclaimer-body-checkbox-div .disclaimer-body-checkbox-clickable:hover {
  cursor: pointer;
}
.disclaimer-body .disclaimer-body-checkbox-div .disclaimer-body-checkbox-text {
  padding-left: 10px;
}`, "",{"version":3,"sources":["webpack://./../../libraries/components/dist/src/ResourcePickerModal/ResourcePickerModal.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;AACJ;;AAEA;EACI,sBAAA;EACA,2BAAA;EACA,wBAAA;EACA,aAAA;AACJ;AACI;EACI,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;AACR;AAEI;EACI,cAAA;AAAR;AAGI;EACI,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AADR;;AAKA;EACI,eAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,iBAAA;EACA,gBAAA;AAFJ;;AAMA;EACI,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,kBAAA;AAHJ;AAKI;EACI,qBAAA;EACA,gBAAA;AAHR;AAMI;EACI,eAAA;EACA,mBAAA;EACA,mBAAA;AAJR;AAOI;EACI,cAAA;EACA,gBAAA;AALR;AAOQ;EACI,mBAAA;AALZ;AAQQ;EACI,eAAA;AANZ;AASQ;EACI,eAAA;AAPZ;AAUQ;EACI,kBAAA;AARZ","sourcesContent":[".resource-picker-header {\n    padding: 15px 15px 0px 15px;\n}\n\n.resource-picker-option {\n    vertical-align: middle;\n    border: 1px solid lightgrey;\n    border-bottom-width: 0px;\n    padding: 15px;\n\n    span {\n        display: inline-block;\n        font-size: 16px;\n        vertical-align: middle;\n        word-break: break-word;\n        max-width: 420px;\n    }\n\n    .resource-picker-filename {\n        color: #a9a9a9;\n    }\n\n    i {\n        display: inline-block;\n        vertical-align: middle;\n        font-size: 40px;\n        padding-left: 20px;\n        padding-right: 40px;\n    }\n}\n\n.resource-picker-option:hover {\n    cursor: pointer;\n    background: #fafaff;\n}\n\n.resource-picker-body-scroll {\n    max-height: 500px;\n    overflow-y: auto;\n}\n\n// Override unwanted bootstrap styles for label\n.resource-picker-file-upload-label {\n    display: initial;\n    max-width: initial;\n    margin-bottom: initial;\n    font-weight: initial;\n}\n\n.disclaimer-body {\n    padding: 20px;\n    border-radius: 3px;\n\n    p {\n        display: inline-block;\n        max-width: 450px;\n    }\n\n    .disclaimer-body-icon {\n        font-size: 40px;\n        padding-right: 20px;\n        vertical-align: top;\n    }\n\n    .disclaimer-body-checkbox-div {\n        display: block;\n        margin-top: 10px;\n\n        .disclaimer-body-checkbox {\n            vertical-align: top;\n        }\n\n        .disclaimer-body-checkbox:hover {\n            cursor: pointer;\n        }\n\n        .disclaimer-body-checkbox-clickable:hover {\n            cursor: pointer;\n        }\n\n        .disclaimer-body-checkbox-text {\n            padding-left: 10px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
